export default "__VITE_ASSET__6jd_2xnY__"